import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Drawer } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
  updateOpenDrawerOrganization,
  updateOrganizationRefreshTable,
} from "../../../redux/organizations/organizationSlice";
// INTERFACE
import { OrganizationInterface } from "../../../interfaces/Organizations.interface";
import { RootState } from "../../../app/store";
// COMPONENTS
import DrawerOrganizationInformation from "../../components/drawer/DrawerOrganizationInformation";
import ButtonClose from "../../components/buttons/ButtonClose";

function OrganizationDrawer() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [data, setData] = useState<OrganizationInterface>();

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { organization, openDrawerOrganization } = useSelector(
    (state: RootState) => state.organization,
  );

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickClose = () => {
    dispatch(updateOpenDrawerOrganization(false));
    dispatch(updateOrganizationRefreshTable(true));
    setTimeout(() => {
      dispatch(updateOrganizationRefreshTable(false));
    }, 1000);
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (organization) {
      setData(organization);
    }
  }, [organization]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Drawer
      width="550"
      placement="right"
      onClose={onClickClose}
      closable={false}
      open={openDrawerOrganization}
      footer={
        <div className="container generalStyles__flex mt-4">
          <div className="generalStyles__width100 generalStyles__mrFix">
            <ButtonClose onClick={onClickClose} />
          </div>
        </div>
      }
    >
      {data && (
        <div>
          {/** COMPONENT ORGANIZATION INFORMATION  */}
          <DrawerOrganizationInformation data={data || {}} />
        </div>
      )}
    </Drawer>
  );
}

export default OrganizationDrawer;
